import {
  createEntityAdapter,
  createSlice,
  type PayloadAction,
} from "@reduxjs/toolkit";
import { ISeller } from "./sellers.types";
import { getSellersThunk } from "./sellers.thunk";

const sellersAdapter = createEntityAdapter<ISeller, string>({
  selectId: (seller: ISeller) => seller.id,
  sortComparer: (a, b) => a.name.localeCompare(b.name),
});

type TExtraState = { loading: boolean; error: string | null };
const initialState = sellersAdapter.getInitialState<TExtraState>({
  loading: false,
  error: null,
});

const sellersSlice = createSlice({
  name: "sellers",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSellersThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        getSellersThunk.fulfilled,
        (state, action: PayloadAction<ISeller[]>) => {
          sellersAdapter.setMany(state, action.payload);
          state.loading = false;
        },
      )
      .addCase(getSellersThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Failed to fetch sellers.";
      });
  },
});

export { sellersAdapter };
export default sellersSlice.reducer;
